<!--表单页面拷贝开始-->
<template>
  <div>
    <form-components @submitForm="submitForm">
      <template v-slot:content>
        <el-form-item label="账号">
          <el-col :span="8">
            <el-input v-model="sysUser.userId"></el-input>
          </el-col>
        </el-form-item>


        <el-form-item label="电子邮箱">
          <el-col :span="8">
            <el-input v-model="sysUser.email"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="真实姓名">
          <el-col :span="8">
            <el-input v-model="sysUser.realName"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="所属角色">
          <el-col :span="8">
        <el-select v-model="sysUser.role" placeholder="请选择">
          <el-option
            v-for="role in roleList"
            :key="role.id"
            :label="role.label"
            :value="role.value"
          >
          </el-option>
        </el-select>
         </el-col>
        </el-form-item>
        <el-form-item label="状态">
          <el-col :span="8">
        <el-select v-model="sysUser.status" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
         </el-col>
        </el-form-item>
      </template>   
    </form-components>
  </div>
</template>

<script>
import FormComponents from "@/components/form/FormComponents";
import SysUserApi from "@/api/SysUserApi";
import RoleApi from "@/api/RoleApi";
import { navTo, queryParam } from "@/utils/NavigatorUtils";
export default {
  name: "SaveSysUserPage",
  props: {
    msg: String,
  },
  components: {
    FormComponents,
  },
  data() {
    return {
      options: [
        {
          value: 1,
          label: "可用",
        },
        {
          value: 0,
          label: "禁用",
        }
      ],
      sysUser: {
        useId: "",
        realName: "",
        email: "",
        status: "",
        id:0,
      },
      roleList:[]
    };
  },
  created() {
    this.sysUser = this.$route.params;
    RoleApi.queryRoleList().then((resp) => {
      if(resp.state=="OK"){
          resp.data.forEach(item => {
            this.roleList.push({"value":item.code,"label":item.name})
          });
      }
    })
  },
  methods: {
    submitForm() {
      this.sysUser.id > 0 ? this.updateSysUserById() : this.addSysUser();
    },
    addSysUser() {
      SysUserApi.saveSysUser(this.sysUser).then((resp) => {
        if (resp.state == "OK") {
          this.sysUser = {};
          this.$successMsg(resp.msg);
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    updateSysUserById() {
      SysUserApi.updateSysUser(this.sysUser).then((resp) => {
        if (resp.state == "OK") {
          this.user = {};
          this.$successMsg(resp.msg);
          navTo(this, "/sysUserList");
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
  },
};
</script>


<!--表单页面拷贝结束-->